var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "timer_FILL0_wght400_GRAD0_opsz20",
    d: "M147.857,169.273V168h4.286v1.273Zm1.5,7.636h1.286v-4.242h-1.286ZM150,182a5.846,5.846,0,0,1-2.338-.469,6.111,6.111,0,0,1-1.9-1.274,6.043,6.043,0,0,1-1.287-1.882,5.894,5.894,0,0,1,0-4.628,6.043,6.043,0,0,1,1.287-1.882,6.111,6.111,0,0,1,1.9-1.274,6,6,0,0,1,4.327-.124,6.735,6.735,0,0,1,1.778.963l.929-.9.893.884-.911.919a6.334,6.334,0,0,1,.973,1.747,5.861,5.861,0,0,1-.125,4.3,6.044,6.044,0,0,1-1.287,1.882,6.111,6.111,0,0,1-1.9,1.274A5.846,5.846,0,0,1,150,182Zm0-1.273a4.57,4.57,0,0,0,3.339-1.361,4.661,4.661,0,0,0,0-6.611,4.777,4.777,0,0,0-6.679,0,4.661,4.661,0,0,0,0,6.611A4.57,4.57,0,0,0,150,180.727ZM150,176.061Z",
    transform: "translate(-144 -168)",
    fill: "#3953fb"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer.70c7f4e0.svg";
export { ForwardRef as ReactComponent };